export default "__VITE_ASSET__98e71c51__"